import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ChargeWaiverRegistrationProvider } from "presentation/store/ChargeWaiverRegistration/ChargeWaiverRegistrationProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { ChargeWaiverRegistrationMaintenance } from "presentation/view/section/ChargeWaiverRegistration/ChargeWaiverRegistrationMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ChargeWaiverRegistrationContMain = () => {
    return <ANAInfoWrapper permission={Permission.CHARGE_WAIVER_REGISTRATION_MAINTENANCE}>
        <MessageBarWrapper>
            <ChargeWaiverRegistrationProvider>
                <GridStyles />
                <ChargeWaiverRegistrationMaintenance />
            </ChargeWaiverRegistrationProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ChargeWaiverRegistrationContMain;